module.exports = __webpack_public_path__ + "static/media/sirak.7932444e.jpg";